import React, { useState } from 'react';
import { callApiPost } from '../Helper/Network';

import hyappLogo from '../resource/hyapp/logo.png';
import haccproLogo from '../resource/haccpro/logo.png'
import { Form, Icon, Button } from 'react-bulma-components';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../locale/useTranslation';
function PasswordForgotten(props) {
    const { t, language, setLanguage } = useTranslation();
    const [email, setEmail] = useState("");

    const navigate = useNavigate();

    const save = async () => {
        var passwordForgotten = {
            email: email,
        }

        try {
            await callApiPost("/require-reset", passwordForgotten);
            navigate("/login");
        }
        catch (error) {
        }
    }

    const handleValidate = (event) => {
        if (event.key === 'Enter') {
          // 👇 Get input value
          save();
        }
      };

    return (
        <>
            <div className="container is-centered">
                <div className="columns is-centered">
                    <div className="column is-12-mobile is-6-tablet is-6-desktop">

                        <div style={{textAlign: 'center', marginTop: '20px'}}>
                            {
                            process.env.REACT_APP_APP_VARIANT === "hyapp" ? <img src={hyappLogo} width="200px" alt="Logo HyAPP" /> : null
                            } 
                            {
                            process.env.REACT_APP_APP_VARIANT === "haccpro" ? <img src={haccproLogo} width="300px" alt="Logo HACCPro" /> : null
                            }             
                        </div>
                        <div className="box" style={{ maxWidth: "400px", margin: "0 auto" }}>
                            <h3 className="title is-5">{t("Mot de passe oublié")}</h3>

                            <div className="field">
                                <label className="label required">{t("E-mail")}</label>
                                <div className="control">
                                    <input
                                    className="input"
                                    type="text"
                                    name="email"
                                    placeholder={t("E-mail")}
                                    value={email}
                                    onChange={e => setEmail(e.target.value)}
                                    onKeyDown={handleValidate}
                                    />
                                </div>
                            </div>


                            <Button.Group style={{justifyContent: 'center'}}>
                                <Button color="black" onClick={save}>
                                <Icon align="left"  style={{marginRight: "0px", marginLeft: "0px"}}>
                                    <i className="fa fa-envelope"/>
                                </Icon>
                                {t("Demander un nouveau mot de passe")}</Button>
                            </Button.Group>  
                        </div>                      
                    </div>
                </div>
            </div>
        </>
    );
}

export default PasswordForgotten;
